import React from 'react';
import Modal from '../../component/Inc/Modal';
import Upload from '../../component/Inc/Upload';
function PopAddMember(props) {
  const {open, close} = props;
  return (
    <Modal open={open} close={close} type="com_input pop_add_member">
      <h2 className="pop_tit">이지 가족 추가</h2>
      <div className="content_container scroll">
        <div className="com_radio_wrap">
          <strong className="tit">구분</strong>
          <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
          <label htmlFor="rdo01">내근직</label>
          <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
          <label htmlFor="rdo02">담임</label>
          <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
          <label htmlFor="rdo03">교사</label>
          <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
          <label htmlFor="rdo04">홍보 </label>
        </div>
        <section className="search search_top">
          <input type="search" placeholder="직원명 검색" className="input s type_search" />
          <button className="com_btn gray ws s icon_search"></button>
        </section>
        <hr className="com_divider" />
        <ul className="com_input_sec">
          <li className="tit_field">입사자명</li>
          <li className="input_field">
            <select className="select">
              <option value="선택">가길동</option>
            </select>
          </li>

          <li className="tit_field">입사일자</li>
          <li className="input_field">
            <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
          </li>
          <li className="tit_field">사진등록</li>
          <li className="input_field">
            <div className="com_input_upload">
              <p className="file">
                <input type="text" className="input" defaultValue={`사진.jpg`} />
              </p>
              <Upload title="+ 파일 찾기" className="com_btn gray xs" />
            </div>
          </li>
          <li className="input_field">
            <textarea className="textarea" placeholder="각오 한마디 입력"></textarea>
          </li>
        </ul>
      </div>
      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
      <div className="btn_container">
        <button className="com_btn gray xs">삭제</button>
        <button className="com_btn orange xs">저장</button>
      </div>
    </Modal>
  );
}

export default PopAddMember;
